import { render, staticRenderFns } from "./ScreenObstetrica1Trimestre.vue?vue&type=template&id=3fe529f7&scoped=true&"
import script from "./ScreenObstetrica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetrica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetrica1Trimestre.vue?vue&type=style&index=0&id=3fe529f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe529f7",
  null
  
)

export default component.exports